import React, { Suspense } from "react";
import Hero from "../components/landingpage/Hero";
import LoadingSpinner from "../components/UI/LoadingSpinner";

// Lazy load components that are below the fold
const Features = React.lazy(() => import("../components/landingpage/Features"));
const About = React.lazy(() => import("../components/landingpage/About"));
const BuiltForYou = React.lazy(
  () => import("../components/landingpage/BuiltForYou")
);
// const TrustedBy = React.lazy(
//   () => import("../components/landingpage/TrustedBy")
// );

const ContactForm = React.lazy(
  () => import("../components/landingpage/ContactForm")
);
const Footer = React.lazy(() => import("../components/landingpage/Footer"));

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <Suspense fallback={<LoadingSpinner />}>
        <About />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <BuiltForYou />
      </Suspense>
      {/* <Suspense fallback={<LoadingSpinner />}>
        <TrustedBy />
      </Suspense> */}
      <Suspense fallback={<LoadingSpinner />}>
        <Features />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <ContactForm />
      </Suspense>
      <Suspense fallback={<LoadingSpinner />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default LandingPage;
